// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mp","tile":"mq","imageWrapper":"mr","img":"ms","header":"mt","caption":"mu"};